<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:39:11+01:00
@Email:  tom@lorinthe.com
@Project: Qrespi corporate website
@Last modified by:   tom
@Last modified time: 2019-05-16T13:58:09+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

  <preorder :label="$t('intro.preorder.progress')" class="bg-white" />

-->

<template lang="html">

  <div>
    <p class="progress-background-lbl mt-2 mb-0" v-html="$t('intro.preorder.payload')"/>

    <b-progress :max="max" height="0.6rem">
      <b-progress-bar
        :value="barValue"
        variant="secondary"/>
      <!-- :label="$t('intro.preorder.progress')" -->
      <icon name="long-arrow-alt-right" class="text-secondary pl-2" scale="2"/>
    </b-progress>
  </div>

</template>

<script>
//
// ********  change targets for progress bar below
//
const NR_PRE_ORDERS = getDayOfYear() < 90 ? getDayOfYear() : 10 // or give actual orders
const TARGET_ORDERS = 90 // or like 1000 = real target
const LOG_SCALE = false
// ********  end change

function getDayOfYear () {
  var now = new Date()
  var start = new Date(now.getFullYear(), 0, 0)
  var diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000)
  var oneDay = 1000 * 60 * 60 * 24
  var day = Math.floor(diff / oneDay)
  // console.log('Day of year: ' + day)
  return day
}

export default {
  data () {
    return {
      preOrder: 0, // animation counter
      max: LOG_SCALE ? Math.log10(TARGET_ORDERS) : TARGET_ORDERS,
      animationValue: NR_PRE_ORDERS / 20 // steps to show to animate
    }
  },
  computed: {
    barValue: function () {
      if (this.preOrder > 0) {
        return LOG_SCALE ? Math.log10(this.preOrder) : this.preOrder
      } else {
        // log10(0) = infinite, so here we need 0
        return 0
      }
    }
  },
  mounted () {
    this.animateBar()
  },
  methods: {
    animateBar: function () {
      var self = this
      setTimeout(function () {
        self.preOrder += self.animationValue
        if (self.preOrder < NR_PRE_ORDERS) {
          self.animateBar()
        } else {
          // finished, we should show full scale
          self.preOrder = NR_PRE_ORDERS
        }
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
